import { MessageCircle } from "lucide-react";
import { getKakaoChannelUrl, useCms } from "@/lib/cms";
import "@/components/FloatingActionButton.css";

export default function KakaoFloatingButton() {
  const { cms } = useCms();
  const kakaoUrl = getKakaoChannelUrl(cms);

  return (
    <a
      href={kakaoUrl}
      target="_blank"
      rel="noreferrer"
      data-testid="kakao-float-button"
      aria-label="카카오톡 상담하기"
      className="ds-fab ds-fab--kakao"
    >
      <MessageCircle size={18} />
    </a>
  );
}
